export enum HHDSButtonGroupType {    
    Default = 'default',
    Toolbar = 'toolbar'
}

export enum HHDSButtonGroupOrientation {
    Horizontal = 'horizontal',
    Vertical = 'vertical'
}